// One flat catalogue per locale in the FormatJS "simple" format, keyed by its
// file name (e.g. `en`).
const files = import.meta.glob<Record<string, string>>("./*.json", {
  eager: true,
  import: "default",
});

const locales: Record<string, Record<string, string>> = Object.fromEntries(
  Object.entries(files).map(([path, messages]) => [path.slice(2, -".json".length), messages]),
);

export function getMessages(language: string): Record<string, string> {
  return locales[language] ?? {};
}
